/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { PureComponent } from "react";
import Styled from "instructor/styles/dashboard";
import CustomDropDown from "instructor/components/dashboard-select";
import CustomDropDownMultiple from "instructor/components/dashboard-select-multiple";
import BarChart from "instructor/components/dashboard-bar-chart";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
} from "recharts";
import EngagementPopup from "instructor/components/engagement-popup";
import PerformancePopup from "instructor/components/performance-popup";
import TeamDynamicsPopup from "instructor/components/team-dynamics-popup";
import StudentStatsPopup from "instructor/components/student-stats-popup";
import { Loader } from "react-loaders";
import { getRequest, batchRequest, downloadRequest, postRequest } from "api/ApiService";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import moment from "moment";
import { CSVLink } from "react-csv";
import styled from 'styled-components';
import Auth from '../../routes/Auth';
import groupBy from 'lodash/groupBy';

import { isSurveyFinished } from '../../api/Surveys';

import ErrorAlert from '../../components/alerts/error';
import ErrorInlineAlert from '../../components/alerts/errorInline';

const { Engagement, Performance, TeamDynamics, Leaderboard } = Styled;

const GAMES_LIST_API = `${process.env.REACT_APP_API_URL}games/`;
const COURSES_LIST_API = `${process.env.REACT_APP_API_URL}courses/`;
const ROUNDS_LIST_API = `${process.env.REACT_APP_API_URL}game/rounds/`;
const PERFORMANCE_METRICS_API = `${process.env.REACT_APP_API_URL}v2/games/teamgradings/overall/`;
const METRICS_REPORT_API = `${process.env.REACT_APP_API_URL}v2/finance/metricsreports/`;
const TEAMS_LIST_API = `${process.env.REACT_APP_API_URL}teams/`;
const SURVEYS_LIST_API = `${process.env.REACT_APP_API_URL}v2/forms/surveys/`;
const TEAM_SCORE_API = `${process.env.REACT_APP_API_URL}v2/forms/surveys/%SURVEY_ID%/team-score/`;
const USER_SCORE_API = `${process.env.REACT_APP_API_URL}v2/forms/userscores/?survey=%SURVEY_ID%`;
const CONSTANTS_LIST_API = `${process.env.REACT_APP_API_URL}static/constants/`;
const COURSE_MEMBERS_LIST_API = `${process.env.REACT_APP_API_URL}course_members/`;
const BULK_SCORING_API = `${process.env.REACT_APP_API_URL}v2/forms/surveys/%SURVEY_ID%/bulk-submission-scoring/`;
const CALC_SURVEY_SCORE_API = `${process.env.REACT_APP_API_URL}v2/forms/surveys/%SURVEY_ID%/calc-score/`;

const doNothing = e => {
  if (e) {
    e.preventDefault();
  }
};

const MODAL_TYPE_WORKED_VERY_WELL = 1;
const MODAL_TYPE_WORKED_WELL = 2;
const MODAL_TYPE_DID_NOT_WORK_WELL = 3;

const DOWNLOAD_MAX_ATTEMPTS = 10;
const DOWNLOAD_ATTEMPT_DELAY = 1000;
const DOWNLOAD_ERROR = 'The system cannot process request. Try again later.';

const teamDynamicsModalTitles = {
  [MODAL_TYPE_WORKED_VERY_WELL]: "Worked Very Well Together",
  [MODAL_TYPE_WORKED_WELL]: "Worked Well Together",
  [MODAL_TYPE_DID_NOT_WORK_WELL]: "Did Not Work Well Together"
};

const teamDynamicsField = {
  [MODAL_TYPE_WORKED_VERY_WELL]: "team_worked_well_together",
  [MODAL_TYPE_WORKED_WELL]: "team_worked_together",
  [MODAL_TYPE_DID_NOT_WORK_WELL]: "team_did_not_worked_together"
};

const CSVDownload = styled(CSVLink)`
  &:active,
  &:visited,
  &:link {
    font-family: 'Mukta Vaani', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    text-decoration: underline;
    color: #fff;
  }

  &:hover {
    text-decoration: none;
  }
`;

class Dashboard extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showEngagementModal: false,
      courses: null,
      games: null,
      rounds: null,
      currentGame: 0,
      currentCourse: 0,
      currentRound: 0,
      setRoundValue: null,
      averageTeamGrade: 0,
      medianTeamGrade: 0,
      standardDeviation: 0,
      metricsReports: null,
      showPerformanceModal: false,
      performanceModalType: "",
      teams: null,
      surveys: null,
      allSurveys: null,
      surveysError: null,
      currentSurvey: 0,
      setSurveyValue: null,
      teamScore: null,
      showTeamDynamicsModal: false,
      teamDynamicsModalTitle: "",
      teamDynamicsTeamsList: [],
      teamDynamicsCurrentTeam: 0,
      teamDynamicsHideDropdowns: false,
      players: null,
      teamDynamicsCurrentPlayer: 0,
      setPlayerValue: null,
      reports: {},
      userScoreReports: {},
      constants: null,
      overall_engagement_case_study: 0,
      overall_engagement_customer_analysis: 0,
      overall_engagement_team_reports: 0,
      overall_class_engagement: 0,
      courseUsers: [],
      engagementUserId: 0,
      engagementUser: "",
      engagementLoading: false,
      engagementCaseStudyValue: 0,
      engagementCustomerAnalysisValue: 0,
      engagementTeamReportsValue: 0,
      engagementRate: 0,
      countOfCourseMembers: 0,
      leaderboard: [],
      leaderboardLoading: true,
      leaderboardFileData: [],
      leaderboardFileDownloading: true,
      sortKey: "classRanking",
      sortOrder: "asc",
      isReportsLoading: false,
      isPlayersLoading: false,
      teamPlayersLoading: false,
      teamPlayers: [],
      competitions: null,
      showStudentStats: false,
      studentStatsLoading: false,
      engagementDownloadRequest: null,
      engagementDownloadCount: 0,
      engagementDownloadFile: null,
      teamDynamicsDownloadRequest: null,
      teamDynamicsDownloadCount: 0,
      teamDynamicsDownloadFile: null,
      performanceDownloadRequest: null,
      performanceDownloadCount: 0,
      performanceDownloadFile: null,
      showPerformanceDowload: true,
      showError: false,
      hasUserScores: false,
      showStudentStatError: false,
      processResultsFailed: false
    };
  }

  downloadPerformanceFile = () => {
    const { performanceDownloadFile } = this.state;

    downloadRequest(performanceDownloadFile, 'application/csv')
      .then(res => res.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `performance_${this.currentDate}.csv`;
        link.click();
      })
      .catch(err => {
        console.error(err);
        alert(DOWNLOAD_ERROR);
      });
  }

  downloadPerformanceData = e => {
    const {
      performanceDownloadRequest,
      currentRound,
      performanceDownloadCount,
      performanceDownloadFile,
      rounds,
      currentGame,
      currentSurvey
    } = this.state;

    if (e) {
      e.preventDefault();
    }

    const selectedRound = rounds.find(round => round.id === currentRound);
    if (!selectedRound.is_finished) {
      this.setState({
        showError: true
      });
      return;
    }

    if (performanceDownloadFile) {
      this.downloadPerformanceFile();
      return;
    }

    if (!performanceDownloadRequest) {
      postRequest(`${process.env.REACT_APP_API_URL}v2/games/usergrade/run/`)
        .send({
          game: currentGame,
          ...(currentSurvey && { survey: currentSurvey })
        })
        .type('form')
        .then(res => {
          if (res.statusCode === 200 || res.statusCode === 201) {
            postRequest(`${process.env.REACT_APP_API_URL}v2/reports/performance-csv-add/`)
              .send({
                round: currentRound,
                ...(currentSurvey ? { survey: currentSurvey } : {})
              })
              .type('form')
              .then(res => {
                const { download_file } = res.body;
                const performanceDownloadRequest = download_file.substring(5);

                this.setState({
                  performanceDownloadRequest,
                  performanceDownloadCount: 0,
                  performanceDownloadFile: null,
                });
              })
              .catch(err => {
                console.error(err);
                alert(DOWNLOAD_ERROR);
              });
          }
        })
        .catch(err => {
          console.error(err);
        });
    } else {
      if (performanceDownloadCount === DOWNLOAD_MAX_ATTEMPTS) {
        alert(DOWNLOAD_ERROR);

        this.setState({
          performanceDownloadCount: 0,
        });
        return;
      }

      this.setState({
        performanceDownloadCount: performanceDownloadCount + 1,
      });

      getRequest(`${process.env.REACT_APP_API_URL}${performanceDownloadRequest}`)
        .then(res => {
          const { status, download_link } = res.body;

          if (status !== 'Completed') {
            setTimeout(this.downloadPerformanceData, DOWNLOAD_ATTEMPT_DELAY);
          } else {
            this.setState({
              performanceDownloadFile: download_link,
              performanceDownloadCount: 0,
            }, () => {
              this.downloadPerformanceFile();
            });
          }
        })
        .catch(err => {
          console.error(err);
          alert(DOWNLOAD_ERROR);
        });
    }
  }

  downloadTeamDynamicsFile = () => {
    const { teamDynamicsDownloadFile } = this.state;

    downloadRequest(teamDynamicsDownloadFile, 'application/csv')
      .then(res => res.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `team_dynamics_${this.currentDate}.csv`;
        link.click();
      })
      .catch(err => {
        console.error(err);
        alert(DOWNLOAD_ERROR);
      });
  }

  downloadTeamDynamicsData = e => {
    const {
      teamDynamicsDownloadRequest,
      currentSurvey,
      teamDynamicsDownloadCount,
      teamDynamicsDownloadFile,
    } = this.state;

    if (e) {
      e.preventDefault();
    }

    if (teamDynamicsDownloadFile) {
      this.downloadTeamDynamicsFile();
      return;
    }

    if (!teamDynamicsDownloadRequest) {
      getRequest(`${process.env.REACT_APP_API_URL}v2/forms/add-export-answers-to-csv-task/${currentSurvey}/`)
        .then(res => {
          const { download_file } = res.body;
          const teamDynamicsDownloadRequest = download_file.substring(5);

          this.setState({
            teamDynamicsDownloadRequest,
            teamDynamicsDownloadCount: 0,
            teamDynamicsDownloadFile: null,
          });
        })
        .catch(err => {
          console.error(err);
          alert(DOWNLOAD_ERROR);
        });
    } else {
      if (teamDynamicsDownloadCount === DOWNLOAD_MAX_ATTEMPTS) {
        alert(DOWNLOAD_ERROR);

        this.setState({
          teamDynamicsDownloadCount: 0,
        });
        return;
      }

      this.setState({
        teamDynamicsDownloadCount: teamDynamicsDownloadCount + 1,
      });

      getRequest(`${process.env.REACT_APP_API_URL}${teamDynamicsDownloadRequest}`)
        .then(res => {
          const { status, download_link } = res.body;

          if (status !== 'Completed') {
            setTimeout(this.downloadTeamDynamicsData, DOWNLOAD_ATTEMPT_DELAY);
          } else {
            this.setState({
              teamDynamicsDownloadFile: download_link,
              teamDynamicsDownloadCount: 0,
            }, () => {
              this.downloadTeamDynamicsFile();
            });
          }
        })
        .catch(err => {
          console.error(err);
          alert(DOWNLOAD_ERROR);
        });
    }
  }

  downloadEngagementFile = () => {
    const { engagementDownloadFile } = this.state;

    downloadRequest(engagementDownloadFile, 'application/csv')
      .then(res => res.blob())
      .then(blob => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `engagement_${this.currentDate}.csv`;
        link.click();
      })
      .catch(err => {
        console.error(err);
        alert(DOWNLOAD_ERROR);
      });
  }

  downloadEngagementData = e => {
    const {
      engagementDownloadRequest,
      currentRound,
      engagementDownloadCount,
      engagementDownloadFile,
    } = this.state;

    if (e) {
      e.preventDefault();
    }

    if (engagementDownloadFile) {
      this.downloadEngagementFile();
      return;
    }

    if (!engagementDownloadRequest) {
      getRequest(`${process.env.REACT_APP_API_URL}v2/engagement/add-export-user-scores-to-csv-task/${currentRound}/`)
        .then(res => {
          const { download_file } = res.body;
          const engagementDownloadRequest = download_file.substring(5);

          this.setState({
            engagementDownloadRequest,
            engagementDownloadCount: 0,
          });
        })
        .catch(err => {
          console.error(err);
          alert(DOWNLOAD_ERROR);
        });
    } else {
      if (engagementDownloadCount === DOWNLOAD_MAX_ATTEMPTS) {
        alert(DOWNLOAD_ERROR);

        this.setState({
          engagementDownloadCount: 0,
        });
        return;
      }

      this.setState({
        engagementDownloadCount: engagementDownloadCount + 1,
      });

      getRequest(`${process.env.REACT_APP_API_URL}${engagementDownloadRequest}`)
        .then(res => {
          const { status, download_link } = res.body;

          if (status !== 'Completed') {
            setTimeout(this.downloadEngagementData, DOWNLOAD_ATTEMPT_DELAY);
          } else {
            this.setState({
              engagementDownloadFile: download_link,
              engagementDownloadCount: 0,
            }, () => {
              this.downloadEngagementFile();
            });
          }
        })
        .catch(err => {
          console.error(err);
          alert(DOWNLOAD_ERROR);
        });
    }
  }

  processUserScores = () => {
    const { currentSurvey } = this.state;

    if (currentSurvey > 0) {
      postRequest(BULK_SCORING_API.replace("%SURVEY_ID%", currentSurvey))
        .then(res => {
          console.log(res.body);
        })
        .catch(err => { });
      postRequest(CALC_SURVEY_SCORE_API.replace("%SURVEY_ID%", currentSurvey))
        .then(res => {
          this.fetchTeamScore();
          this.fetchUserScore();
        })
        .catch(err => { });
    }
  }

  showStudentStats = () => {
    this.setState({
      showStudentStats: true,
      studentStatsLoading: true,
    });
  }

  hideStudentStats = () => {
    this.setState({
      showStudentStats: false,
    });
  }

  setStudentsStatsLoading = (value) => {
    this.setState({
      studentStatsLoading: value,
    });
  }

  selectCourse = () => {
    const { courses, games, currentGame } = this.state;
    const game = games.find(i => i.id === currentGame);

    if (game) {
      const { course: currentCourse } = game;
      const course = courses.find(i => i.id === currentCourse);

      if (course) {
        this.setState(
          {
            currentCourse: course.id
          },
          () => {
            this.fetchCourseUsers();
          }
        );
      }
    }
  };

  fetchCourseUsers = () => {
    const { currentCourse, courses } = this.state;
    const course = courses.find(i => i.id === currentCourse);

    if (course) {
      getRequest(`${process.env.REACT_APP_API_URL}users/`)
        .then(res => {
          const courseUsers = orderBy(
            res.body
              .filter(i => course.users.includes(i.id))
              .filter(
                i => i.email !== "" && i.first_name !== "" && i.last_name !== ""
              )
              .map(i => ({
                id: i.id,
                name: `${i.first_name} ${i.last_name}`
              })),
            ["name"],
            ["asc"]
          );

          this.setState({
            courseUsers
          });
        })
        .catch(err => { });
    }
  };

  showTeamDynamicsModal = (type) => (e) => {
    e.preventDefault();
    const { teamScore, teams } = this.state;

    this.setState({
      showTeamDynamicsModal: true,
      teamDynamicsModalTitle: teamDynamicsModalTitles[type],
      teamDynamicsTeamsList: teamScore
        ? teams.filter(team =>
          get(teamScore.collaboration, teamDynamicsField[type], []).includes(
            team.id
          )
        )
        : []
    });
  };

  hideTeamDynamicsModal = () => {
    this.setState({
      showTeamDynamicsModal: false,
      teamDynamicsModalTitle: "",
      teamDynamicsTeamsList: [],
      teamDynamicsCurrentTeam: 0,
      teamDynamicsHideDropdowns: false,
      players: null,
      teamDynamicsCurrentPlayer: 0,
      setPlayerValue: null,
      reports: {},
      userScoreReports: {},
    });
  };

  showPerformanceModal = performanceModalType => {
    this.setState({
      showPerformanceModal: true,
      performanceModalType
    });
  };

  hidePerformanceModal = () => {
    this.setState({
      showPerformanceModal: false,
      performanceModalType: ""
    });
  };

  componentDidMount() {
    this.fetchData();

    this.fetchPaginationData(
      `${process.env.REACT_APP_API_URL}v2/games/teamgradings/?ordering=-weighted_value`,
      'leaderboardLoading',
      'leaderboard',
      100,
    );
    this.fetchPaginationData(
      `${process.env.REACT_APP_API_URL}v2/games/teamplayers/`,
      'teamPlayersLoading',
      'teamPlayers',
      500,
    );
  }

  fetchData = () => {
    batchRequest([
      TEAMS_LIST_API,
      COURSES_LIST_API,
      ROUNDS_LIST_API,
      SURVEYS_LIST_API,
      CONSTANTS_LIST_API,
      GAMES_LIST_API,
      COURSE_MEMBERS_LIST_API,
      `${process.env.REACT_APP_API_URL}competitions/`,
    ])
      .then(res => {
        const teams = res[0].body;
        const courses = res[1].body;
        const rounds = res[2].body;
        let surveys = res[3].body;
        let finishedSurveys = [];
        let surveysError = null;
        if (res[3].statusCode !== 200) {
          surveysError = surveys;
          surveys = null;
        } else {
          surveys = surveys.results;
          if (surveys && surveys.length > 0) {
            finishedSurveys = surveys.filter(i => isSurveyFinished(i))
          }
        }
        const constants = res[4].body;
        const games = res[5].body;
        const course_members = res[6].body;
        const competitions = res[7].body;

        const ids = courses.map(i => i.id);
        const gamesFiltered = games.filter(i => ids.includes(i.course));
        const coursesFiltered = gamesFiltered
          .map(i => i.course)
          .filter((value, index, self) => self.indexOf(value) === index);
        const countOfCourseMembers = course_members.filter(i =>
          coursesFiltered.includes(i.course)
        ).length;

        if (surveysError) {
          console.error('SURVEYS API ERROR', surveysError);
        }

        this.setState(
          {
            teams,
            courses,
            rounds,
            surveys: finishedSurveys,
            allSurveys: surveys,
            surveysError,
            constants,
            games: gamesFiltered,
            countOfCourseMembers,
            competitions,
          },
          () => {
            const { games } = this.state;

            if (games && games.length > 0) {
              const game = games[0];

              this.selectGame(game.name);
            }
          }
        );
      })
      .catch(err => { });
  };

  fetchEngagement = () => {
    const { currentRound, currentCourse, rounds } = this.state;
    const round = rounds.find(i => i.id === currentRound);

    if (round) {
      getRequest(
        `${process.env.REACT_APP_API_URL}v2/engagement/engagementoverallscores/?course=${currentCourse}`
      )
        .then(res => {
          const { results } = res.body;
          const result = results && results.length > 0 ? results.find(i => i.round_number === round.number) : null;

          if (result) {
            let {
              overall_engagement_case_study,
              overall_engagement_customer_analysis,
              overall_engagement_team_reports,
              overall_class_engagement
            } = result;

            if (!overall_engagement_case_study) {
              overall_engagement_case_study = 0;
            }

            if (!overall_engagement_customer_analysis) {
              overall_engagement_customer_analysis = 0;
            }

            if (!overall_engagement_team_reports) {
              overall_engagement_team_reports = 0;
            }

            if (!overall_class_engagement) {
              overall_class_engagement = 0;
            }

            this.setState({
              overall_engagement_case_study: Number(
                Number(overall_engagement_case_study).toFixed(2)
              ),
              overall_engagement_customer_analysis: Number(
                Number(overall_engagement_customer_analysis).toFixed(2)
              ),
              overall_engagement_team_reports: Number(
                Number(overall_engagement_team_reports).toFixed(2)
              ),
              overall_class_engagement: Number(
                Number(overall_class_engagement).toFixed(2)
              ),
            });
          } else {
            this.setState({
              overall_engagement_case_study: 0,
              overall_engagement_customer_analysis: 0,
              overall_engagement_team_reports: 0,
              overall_class_engagement: 0,
            });
          }
        })
        .catch(err => { });
    }
  };

  fetchPaginationData = (url, loadingField, dataField, pageSize) => {
    this.setState({
      [loadingField]: true,
      [dataField]: [],
    });

    getRequest(`${url}${url.indexOf('?') > 0 ? '&' : '?'}page_size=1`)
      .then(res => {
        const { count } = res.body;

        if (count > 0) {
          const pages = Math.ceil(count / pageSize);
          const requests = [];

          for (let i = 1; i <= pages; i++) {
            requests.push(`${url}${url.indexOf('?') > 0 ? '&' : '?'}page_size=${pageSize}&page=${i}`);
          }

          batchRequest(requests)
            .then(res => {
              try {
                const data = res.flatMap(payload => payload.body.results);

                this.setState({
                  [loadingField]: false,
                  [dataField]: data,
                });
              } catch (e) {
                console.log(e);
              }
            })
            .catch(err => { });
        } else {
          this.setState({
            [loadingField]: false,
          });
        }
      })
      .catch(err => { });
  }

  fetchTeamScore = () => {
    const { currentSurvey } = this.state;

    if (currentSurvey > 0) {
      getRequest(TEAM_SCORE_API.replace("%SURVEY_ID%", currentSurvey))
        .then(res => {
          this.setState({
            teamScore: res.body,
            processResultsFailed: !res.body.collaboration
          });
        })
        .catch(err => { });
    }
  };

  fetchUserScore = () => {
    const { currentSurvey } = this.state;

    if (currentSurvey > 0) {
      getRequest(USER_SCORE_API.replace("%SURVEY_ID%", currentSurvey))
        .then(res => {
          this.setState({
            hasUserScores: Number(res.body.count) > 0,
          });
        })
        .catch(err => { });
    }
  };

  showEngagementModal = currentUser => {
    const { courseUsers } = this.state;
    const selected = courseUsers.find(i => i.id === currentUser);

    this.setState(
      {
        showEngagementModal: true,
        engagementUser: selected ? selected.name : "",
        engagementLoading: true,
        engagementUserId: Number(currentUser)
      },
      () => {
        this.loadEngagementData();
      }
    );
  };

  loadEngagementData = () => {
    const { currentRound, engagementUserId, rounds } = this.state;
    const round = rounds.find(i => i.id === currentRound);

    if (round) {
      getRequest(
        `${process.env.REACT_APP_API_URL}v2/engagement/engagementuserscores/?user=${engagementUserId}`
      )
        .then(res => {
          const { results } = res.body;
          const result = results && results.length > 0 ? results.find(i => i.round_number === round.number) : null;
          if (result) {
            const {
              overall_user_engagement,
              user_engagement_case_study,
              user_engagement_customer_analysis,
              user_engagement_team_reports
            } = result;

            const engagementCaseStudyValue = user_engagement_case_study
              ? Number((Number(user_engagement_case_study) * 100).toFixed(2))
              : 0;
            const engagementCustomerAnalysisValue = user_engagement_customer_analysis
              ? Number((Number(user_engagement_customer_analysis) * 100).toFixed(2))
              : 0;
            const engagementTeamReportsValue = user_engagement_team_reports
              ? Number((Number(user_engagement_team_reports) * 100).toFixed(2))
              : 0;
            const engagementRate = overall_user_engagement
              ? Number((Number(overall_user_engagement) * 100).toFixed(2))
              : 0;

            this.setState({
              engagementLoading: false,
              engagementCaseStudyValue,
              engagementCustomerAnalysisValue,
              engagementTeamReportsValue,
              engagementRate
            });
          } else {
            this.setState({
              engagementLoading: false,
              engagementCaseStudyValue: 0,
              engagementCustomerAnalysisValue: 0,
              engagementTeamReportsValue: 0,
              engagementRate: 0,
            });
          }
        })
        .catch(err => { });
    }
  };

  checkPerformanceDownloadAbility = () => {
    const { currentSurvey, currentRound, rounds } = this.state;
    const userId = Auth.getUserId();
    const round = rounds.find(i => i.id === currentRound);

    if (round) {
      getRequest(`
        ${process.env.REACT_APP_API_URL}v2/games/usergrade/${currentSurvey}/${round.number}/${userId}
      `)
        .then(res => {
          if (res.body) {
            this.setState({
              showPerformanceDowload: true
            });
          }
        })
        .catch(err => { });
    }
  }

  hideEngagementModal = () => {
    this.setState({
      showEngagementModal: false,
      engagementUserId: 0,
      engagementUser: "",
      engagementLoading: false,
      engagementCaseStudyValue: 0,
      engagementCustomerAnalysisValue: 0,
      engagementTeamReportsValue: 0,
      engagementRate: 0
    });
  };

  get isLoading() {
    const { courses, games, rounds, teams, constants, surveys, surveysError } = this.state;

    return (
      courses === null ||
      games === null ||
      rounds === null ||
      teams === null ||
      constants === null ||
      (surveys === null && surveysError === null)
    );
  }

  get rounds() {
    const { currentGame, rounds } = this.state;

    return currentGame > 0 && rounds
      ? rounds
        .filter(
          round => round.game === currentGame && round.is_finished === true
        )
        .map(round => `Round ${round.number}`)
      : [];
  }

  selectGame = value => {
    const { games } = this.state;

    if (games) {
      const game = games.find(i => i.name === value);
      if (game) {
        this.setState(
          {
            currentGame: game.id,
            currentRound: 0,
            averageTeamGrade: 0,
            medianTeamGrade: 0,
            standardDeviation: 0,
            metricsReports: null,
            courseUsers: [],
          },
          () => {
            this.selectCourse();
            this.updateCurrentRound();
          }
        );
      }
    }
  };

  selectRound = value => {
    const { rounds } = this.state;

    if (rounds && value) {
      let roundNumber = parseInt(value.replace("Round ", ""), 10);
      if (isNaN(roundNumber)) {
        roundNumber = 0;
      }

      if (roundNumber > 0) {
        const round = rounds.find(i => i.number === roundNumber);
        if (round) {
          this.setState(
            {
              currentRound: round.id,
              engagementDownloadRequest: null,
              engagementDownloadCount: 0,
              engagementDownloadFile: null,
              performanceDownloadRequest: null,
              performanceDownloadCount: 0,
              performanceDownloadFile: null,
            },
            () => {
              this.fetchPerformanceMetrics();
              this.fetchEngagement();
              this.fetchPaginationData(
                `${process.env.REACT_APP_API_URL}v2/games/teamgradings/?round=${round.id}`,
                'leaderboardFileDownloading',
                'leaderboardFileData',
                100,
              );
            }
          );
        }
      }
    }
  };

  selectSurvey = value => {
    const { surveys } = this.state;

    if (surveys) {
      const survey = surveys.find(i => i.name === value);
      if (survey) {
        this.setState(
          {
            currentSurvey: survey.id,
            teamDynamicsDownloadRequest: null,
            teamDynamicsDownloadCount: 0,
            teamDynamicsDownloadFile: null,
          },
          () => {
            this.fetchTeamScore();
            this.fetchUserScore();
          }
        );
      }
    }
  };

  get surveys() {
    const { surveys } = this.state;

    return surveys ? surveys
      .filter(survey => this.isSurveyFinished(survey))
      .map(survey => survey.name) : [];
  }

  isSurveyFinished = survey => {
    const currentDate = moment.utc();

    return !(
      currentDate.isSameOrAfter(moment(survey.start)) &&
      currentDate.isSameOrBefore(moment(survey.end))
    );
  };

  isSurveyReallyFinished = survey => {
    const currentDate = moment.utc();

    return currentDate.isAfter(moment(survey.end));
  }

  fetchPerformanceMetrics = () => {
    const { currentRound } = this.state;

    if (currentRound > 0) {
      getRequest(`${PERFORMANCE_METRICS_API}${currentRound}/`)
        .then(res => {
          const {
            average_team_grade,
            median_team_grade,
            standard_deviation
          } = res.body;

          this.setState({
            averageTeamGrade: average_team_grade,
            medianTeamGrade: median_team_grade,
            standardDeviation: standard_deviation
          });
        })
        .catch(err => { });

      getRequest(`${METRICS_REPORT_API}`)
        .then(res => {
          this.setState({
            metricsReports: res.body.results
          });
        })
        .catch(err => { });
    }
  };

  setRoundValue = callback => {
    this.setState(
      {
        setRoundValue: callback
      },
      () => {
        this.updateCurrentRound();
      }
    );
  };

  setSurveyValue = callback => {
    this.setState(
      {
        setSurveyValue: callback
      },
      () => {
        const { setSurveyValue } = this.state;
        const surveys = this.surveys;

        if (surveys.length > 0) {
          setSurveyValue(surveys[surveys.length - 1]);
        }
      }
    );
  };

  setPlayerValue = callback => {
    this.setState({
      setPlayerValue: callback
    });
  };

  updateCurrentRound = () => {
    const { setRoundValue } = this.state;
    const rounds = this.rounds;

    if (rounds.length > 0) {
      setRoundValue(rounds[rounds.length - 1]);
    } else {
      setRoundValue(null);
    }
  };

  get roundNumber() {
    const { currentRound, rounds } = this.state;
    const round = rounds.find(i => i.id === currentRound);

    return round ? round.number : 0;
  }

  get totalTeams() {
    const { teamScore } = this.state;

    return teamScore ? get(teamScore.collaboration, "total_teams", 0) : "---";
  }

  get workedVeryWellTogether() {
    const { teamScore } = this.state;

    return teamScore
      ? (get(teamScore.collaboration, "team_worked_well_together", []).length /
        get(teamScore.collaboration, "total_teams", 0)) *
      100
      : 0;
  }

  get workedVeryWellTogetherTeams() {
    const { teamScore } = this.state;

    return teamScore
      ? get(teamScore.collaboration, "team_worked_well_together", []).length : 0;
  }

  get didNotWorkWellTogether() {
    const { teamScore } = this.state;

    return teamScore
      ? (get(teamScore.collaboration, "team_did_not_worked_together", [])
        .length /
        get(teamScore.collaboration, "total_teams", 0)) *
      100
      : 0;
  }

  get didNotWorkWellTogetherTeams() {
    const { teamScore } = this.state;

    return teamScore
      ? get(teamScore.collaboration, "team_did_not_worked_together", []).length : 0;
  }

  get workedWellTogether() {
    const { teamScore } = this.state;

    return teamScore
      ? (get(teamScore.collaboration, "team_worked_together", []).length /
        get(teamScore.collaboration, "total_teams", 0)) *
      100
      : 0;
  }

  get workedWellTogetherTeams() {
    const { teamScore } = this.state;

    return teamScore
      ? get(teamScore.collaboration, "team_worked_together", []).length : 0;
  }

  teamDynamicsSelectTeam = value => {
    this.setState(
      {
        teamDynamicsCurrentTeam: value,
        teamDynamicsCurrentPlayer: 0,
        players: null,
        isPlayersLoading: true
      },
      () => {
        this.fetchPlayers();
      }
    );
  };

  popupSelectPlayer = value => {
    this.setState(
      {
        teamDynamicsCurrentPlayer: parseInt(value, 10),
        reports: {},
        userScoreReports: {},
        isReportsLoading: true
      },
      () => {
        const { surveys, teamDynamicsCurrentPlayer } = this.state;
        const finishedSurveys = surveys ? surveys.filter(survey =>
          this.isSurveyFinished(survey)
        ) : [];

        this.loadReports(finishedSurveys, teamDynamicsCurrentPlayer);
        this.loadUserScoreReports(finishedSurveys, teamDynamicsCurrentPlayer);
      }
    );
  };

  loadUserScoreReports = (surveys, receiver_id) => {
    const requests = surveys.filter(s => this.isSurveyReallyFinished(s)).map(({ id: survey_id }) =>
      getRequest(
        `${process.env.REACT_APP_API_URL}v2/forms/surveys/${survey_id}/user-score/${receiver_id}/`,
        (res) => res.status === 200 || res.status === 404,
      )
    );
    const stages = surveys.reduce(
      (result, { id: survey_id, stage }) => ({
        ...result,
        [survey_id]: stage,
      }),
      {}
    );

    Promise.all(requests)
      .then(responses => {
        const getSurveyIdFromUrl = url => {
          const tmp = url.split('/');

          return tmp[tmp.length - 4];
        };

        return responses.map(res => ({
          body: res.body,
          stage: stages[getSurveyIdFromUrl(res.req.url)],
        }));
      })
      .then(responses => {
        const userScoreReports = responses.reduce(
          (result, { body, stage }) => body.detail && body.detail === 'Not found.' ? result : ({
            ...result,
            [stage]: body,
          }),
          {}
        );

        this.setState({
          userScoreReports,
        });
      })
      .catch(err => {
        console.error(err);
      });
  };

  loadReports = (surveys, receiver_id) => {
    const requests = surveys.filter(s => this.isSurveyReallyFinished(s)).map(({ id: survey_id }) =>
      getRequest(
        `${process.env.REACT_APP_API_URL}v2/forms/score/${receiver_id}/${survey_id}/`,
        (res) => res.status === 200 || res.status === 404,
      )
    );
    const stages = surveys.reduce(
      (result, { id: survey_id, stage }) => ({
        ...result,
        [survey_id]: stage
      }),
      {}
    );

    Promise.all(requests)
      .then(responses => {
        const getSurveyIdFromUrl = url => {
          const tmp = url.split("/");

          return tmp[tmp.length - 2];
        };

        const prepareResponseBody = res => {
          const body = res.body;
          if (!body.average_user_score) {
            body.average_user_score = 0;
          }

          if (!body.team_average_score) {
            body.team_average_score = 0;
          }

          if (!body.team_median_score) {
            body.team_median_score = 0;
          }

          return body;
        };

        return responses.map(res => ({
          body: prepareResponseBody(res),
          stage: stages[getSurveyIdFromUrl(res.req.url)]
        }));
      })
      .then(responses => {
        const reports = responses.reduce(
          (result, { body, stage }) => body.detail && body.detail === 'Not found.' ? result : ({
            ...result,
            [stage]: body
          }),
          {}
        );

        this.setState({
          reports,
          isReportsLoading: false
        });
      })
      .catch(err => {
        this.setState({
          isReportsLoading: false
        });
      });
  };

  loadReport = async ({ id: survey_id, stage }, receiver_id) => {
    const { body: report } = await getRequest(
      `${process.env.REACT_APP_API_URL}v2/forms/score/${receiver_id}/${survey_id}/`
    );
    const { reports } = this.state;

    this.setState({
      reports: {
        ...reports,
        [stage]: report
      }
    });
  };

  fetchPlayers = () => {
    const { teamDynamicsCurrentTeam } = this.state;

    getRequest(`${TEAMS_LIST_API}${teamDynamicsCurrentTeam}/players/`)
      .then(res => {
        this.setState({
          players: res.body
            .filter(player => "user" in player)
            .map(player => player.user),
          isPlayersLoading: false
        });
      })
      .catch(err => { });
  };

  get engagementRate() {
    const { engagementRate } = this.state;

    return engagementRate >= 75
      ? "High"
      : engagementRate >= 50
        ? "Medium"
        : "Low";
  }

  get engagementRateDescription() {
    const { engagementRate } = this.state;

    return engagementRate >= 75
      ? "75% or more"
      : engagementRate >= 50
        ? "at least 50%"
        : "less than 50%";
  }

  changeSortOrder = key => {
    const { sortKey, sortOrder } = this.state;

    let newSortKey = sortKey;
    let newSortOrder = sortOrder;

    if (newSortKey !== key) {
      newSortKey = key;
      newSortOrder = "asc";
    } else {
      newSortOrder = newSortOrder === "asc" ? "desc" : "asc";
    }

    this.setState({
      sortKey: newSortKey,
      sortOrder: newSortOrder
    });
  };

  get leaderboardCSVHeaders() {
    return [
      { label: "Team name", key: "team_name" },
      { label: "Round", key: "round_number" },
      { label: "Round Score", key: "round_score" },
      { label: "Cumulative Score", key: "cumulative_score" },
      { label: "Rank", key: "rank" },
    ];
  }

  get leaderboardCSVRows() {
    const { leaderboardFileData, teams } = this.state;

    return leaderboardFileData.map(row => ({
      team_name: this.getTeamName(teams, Number(row.team)),
      round_number: Number(row.round_number),
      round_score: Number(row.current_weighted_value),
      cumulative_score: Number(row.weighted_value),
      rank: row.ranking,
    }));
  }

  getClassRankings = items => {
    const values = Object.keys(groupBy(items, "weighted_value"));
    const result = {};
    let counter = 0;
    values.forEach(value => {
      counter++;
      result[value] = counter;
    });

    return result;
  };

  getTeamName = (teams, team_id) => {
    const team = teams.find(i => i.id === team_id);

    return team ? team.name : "";
  };

  getDetailsLink = (team_id, round_number, game_id) => {
    return `/analysis/team-reports?team_id=${team_id}&round=${round_number}&game_id=${game_id}&_token=${Auth.getToken()}&_userid=${Auth.getUserId()}&_courseid=${Auth.getCourseId()}`;
  };

  get leaderboardData() {
    const {
      leaderboard,
      currentRound,
      sortKey,
      sortOrder,
      teams,
      rounds,
    } = this.state;
    const round = rounds ? rounds.find(i => i.id === currentRound) : null;
    const roundNumber = round ? round.number : 0;

    const items = leaderboard
      ? leaderboard.filter(i => i.round === currentRound)
      : [];
    const rankings = this.getClassRankings(items);
    const results = items.map(({ weighted_value, ranking, team, game }, i) => ({
      key: i,
      classRanking: rankings[weighted_value],
      classRankingSort: rankings[weighted_value],
      teamName: this.getTeamName(teams, team),
      teamNameSort: this.getTeamName(teams, team),
      competitionRanking: ranking,
      teamPerformance: `${(weighted_value * 100).toFixed(2)}%`,
      teamPerformanceSort: weighted_value,
      detailsLink: this.getDetailsLink(team, roundNumber, game)
    }));


    return orderBy(results, [`${sortKey}Sort`], [sortOrder]);
  }

  get currentDate() {
    const [year, month, day] = new Date()
      .toISOString()
      .split('T')[0]
      .split('-');

    return `${year}-${day}-${month}`;
  }

  hideError = () => {
    this.setState({
      showError: false
    });
  };

  onStudentStatMouseEnter = () => {
    this.setState({
      showStudentStatError: true
    });
  };

  onStudentStatMouseLeave = () => {
    this.setState({
      showStudentStatError: false
    });
  };

  render() {
    const {
      showEngagementModal,
      averageTeamGrade,
      medianTeamGrade,
      standardDeviation,
      metricsReports: metricsReportsAll,
      showPerformanceModal,
      performanceModalType,
      teams,
      showTeamDynamicsModal,
      teamDynamicsModalTitle,
      teamDynamicsTeamsList,
      teamDynamicsCurrentTeam,
      players,
      teamDynamicsCurrentPlayer,
      setPlayerValue,
      reports,
      userScoreReports,
      surveys,
      allSurveys,
      surveysError,
      constants,
      currentGame,
      currentSurvey,
      overall_class_engagement,
      overall_engagement_case_study,
      overall_engagement_customer_analysis,
      overall_engagement_team_reports,
      courseUsers,
      engagementUser,
      engagementLoading,
      engagementCaseStudyValue,
      engagementCustomerAnalysisValue,
      engagementTeamReportsValue,
      countOfCourseMembers,
      currentRound,
      isReportsLoading,
      isPlayersLoading,
      teamDynamicsHideDropdowns,
      leaderboardLoading,
      leaderboardFileDownloading,
      sortOrder,
      sortKey,
      teamPlayersLoading,
      showStudentStats,
      studentStatsLoading,
      engagementDownloadRequest,
      teamDynamicsDownloadRequest,
      performanceDownloadRequest,
      showPerformanceDowload,
      hasUserScores,
      showError,
      rounds,
      showStudentStatError,
      processResultsFailed
    } = this.state;
    const { isMenuExpanded } = this.props;

    if (this.isLoading === true) {
      return (
        <Styled.Body>
          <Loader type="ball-scale-ripple" active />
        </Styled.Body>
      );
    }

    const roundNumber = this.roundNumber;
    const metricsReports = metricsReportsAll ? metricsReportsAll.filter(i => i.round === currentRound) : null;
    const currentDate = this.currentDate;

    const emptySurveys = !allSurveys || allSurveys.length === 0;
    const activeSurvey = allSurveys ? allSurveys.find(i => i.id === currentSurvey) : null;
    const activeSurveyFinished = activeSurvey ? this.isSurveyFinished(activeSurvey) : false;

    const survey = surveys ? surveys.find(i => i.id === currentSurvey) : null;
    const currentSurveyName = survey ? survey.name : null;

    const selectedRound = rounds.find(round => round.id === currentRound);
    const selectedRoundFinished = selectedRound ? selectedRound.is_finished : false;

    return (
      <Styled.Body>
        {showError && (
          <ErrorAlert
            title="Round is still live!"
            message="Round has not ended yet."
            onHide={this.hideError}
          />
        )}
        <EngagementPopup
          show={showEngagementModal}
          onHide={this.hideEngagementModal}
          username={engagementUser}
          loading={engagementLoading}
          caseStudy={engagementCaseStudyValue}
          customerAnalysis={engagementCustomerAnalysisValue}
          teamReports={engagementTeamReportsValue}
          rate={this.engagementRate}
          rateDescription={this.engagementRateDescription}
        />
        {showStudentStats && (
          <StudentStatsPopup
            show={showStudentStats}
            onHide={this.hideStudentStats}
            loading={studentStatsLoading}
            setLoadingState={this.setStudentsStatsLoading}
            roundId={currentRound}
            roundNumber={roundNumber}
            gameId={currentGame}
            survey={survey}
            reports={reports ? reports : {}}
            selectPlayer={this.popupSelectPlayer}
          />
        )}
        <PerformancePopup
          show={showPerformanceModal}
          type={performanceModalType}
          onHide={this.hidePerformanceModal}
          metricsReports={metricsReports}
          teams={teams}
          constants={constants}
          currentGame={currentGame}
          roundNumber={roundNumber}
        />
        <TeamDynamicsPopup
          show={showTeamDynamicsModal}
          onHide={this.hideTeamDynamicsModal}
          teams={teamDynamicsTeamsList}
          title={teamDynamicsModalTitle}
          currentTeam={teamDynamicsCurrentTeam}
          selectTeam={this.teamDynamicsSelectTeam}
          players={players ? players : []}
          currentPlayer={teamDynamicsCurrentPlayer}
          selectPlayer={this.popupSelectPlayer}
          setPlayerValue={setPlayerValue}
          setPlayerValueCallback={this.setPlayerValue}
          reports={reports ? reports : {}}
          userScoreReports={userScoreReports ? userScoreReports : {}}
          surveys={surveys ? surveys : []}
          allTeams={teams}
          isSurveyFinished={this.isSurveyFinished}
          currentSurvey={currentSurvey}
          isReportsLoading={isReportsLoading}
          isPlayersLoading={isPlayersLoading}
          hideDropdowns={teamDynamicsHideDropdowns}
        />
        <Styled.Title>
          Hi Professor,
        </Styled.Title>
        <Styled.Description>
          <Styled.DescriptionText>
            Select a <span>Round</span> or <span>Peer Evaluation</span> to view the class summary:
          </Styled.DescriptionText>
          <div>
            <CustomDropDownMultiple
              options1={this.rounds}
              options2={this.surveys}
              placeholder="Select Round or Peer Evaluation"
              onChange1={this.selectRound}
              onChange2={this.selectSurvey}
              DropDownListContainer={Styled.AbsoluteListContainer}
              setValueCallback1={this.setRoundValue}
              setValueCallback2={this.setSurveyValue}
              DropDownHeader={Styled.SurveyDropDown}
              DropDownList={Styled.SurveyDropDownList}
            />
          </div>
          <Styled.StudentStatsButton
            onClick={this.showStudentStats}
            disabled={!selectedRoundFinished}
            onMouseEnter={!selectedRoundFinished ? this.onStudentStatMouseEnter : null}
            onMouseLeave={!selectedRoundFinished ? this.onStudentStatMouseLeave : null}
          >
            View Student Stats
          </Styled.StudentStatsButton>
          <Styled.StudentsErrorContainer>
            {
              showStudentStatError &&
              <ErrorInlineAlert
                title="Data is Unavailable"
                message="The round has not ended."
              />
            }
          </Styled.StudentsErrorContainer>
        </Styled.Description>
        <Styled.Flex isMenuExpanded={isMenuExpanded}>
          <div>
            <Styled.Row>
              <Styled.Block isMenuExpanded={isMenuExpanded}>
                <Styled.BlockTitle>
                  <Engagement.Title>
                    <b>Engagement</b> (no. of students, %)
                  </Engagement.Title>
                  <Styled.DownloadLink href="#" onClick={this.downloadEngagementData}>
                    {engagementDownloadRequest ? 'Download Data' : 'Download Request'}
                  </Styled.DownloadLink>
                </Styled.BlockTitle>
                <Styled.BlockContent>
                  <Styled.BlockHint>
                    Round {roundNumber}
                  </Styled.BlockHint>
                  <Engagement.Columns>
                    <Engagement.LeftColumn>
                      <Engagement.PercentAmount>
                        <Engagement.PercentAmountValue>
                          {overall_class_engagement}
                        </Engagement.PercentAmountValue>
                        <Engagement.PercentAmountPercent>
                          ({
                            countOfCourseMembers > 0
                              ? Number(
                                (
                                  (overall_class_engagement /
                                    countOfCourseMembers) *
                                  100
                                ).toFixed(2)
                              )
                              : 0
                          }%)
                        </Engagement.PercentAmountPercent>
                      </Engagement.PercentAmount>
                      <Engagement.Description>
                        Students reviewed
                        <br />
                        most of the data that
                        <br />
                        will help them make
                        <br />
                        informed decisions.
                      </Engagement.Description>
                    </Engagement.LeftColumn>
                    <Engagement.RightColumn>
                      <Engagement.Dropdown>
                        <CustomDropDown
                          options={courseUsers}
                          placeholder="Student Name"
                          onChange={this.showEngagementModal}
                          customId="id"
                          customName="name"
                          DropDownHeader={Engagement.DropDownHeader}
                          DropDownList={Engagement.DropDownList}
                        />
                      </Engagement.Dropdown>
                      <Engagement.Chart>
                        <Engagement.ChartTitle>
                          Case Study
                          <br />
                          ({overall_engagement_case_study}, {
                            countOfCourseMembers > 0
                              ? Number(
                                (
                                  (overall_engagement_case_study /
                                    countOfCourseMembers) *
                                  100
                                ).toFixed(2)
                              )
                              : 0
                          }%)
                        </Engagement.ChartTitle>
                        <BarChart
                          height={60}
                          color="#fbedd5"
                          value={
                            countOfCourseMembers > 0
                              ? Number(
                                (
                                  (overall_engagement_case_study /
                                    countOfCourseMembers) *
                                  100
                                ).toFixed(2)
                              )
                              : 0
                          }
                        />
                      </Engagement.Chart>
                      <Engagement.Chart marginTop="16px">
                        <Engagement.ChartTitle>
                          Customer Analysis
                          <br />
                          ({overall_engagement_customer_analysis}, {
                            countOfCourseMembers > 0
                              ? Number(
                                (
                                  (overall_engagement_customer_analysis /
                                    countOfCourseMembers) *
                                  100
                                ).toFixed(2)
                              )
                              : 0
                          }%)
                        </Engagement.ChartTitle>
                        <BarChart
                          height={60}
                          color="#fbd8d8"
                          value={
                            countOfCourseMembers > 0
                              ? Number(
                                (
                                  (overall_engagement_customer_analysis /
                                    countOfCourseMembers) *
                                  100
                                ).toFixed(2)
                              )
                              : 0
                          }
                        />
                      </Engagement.Chart>
                      <Engagement.Chart marginTop="16px">
                        <Engagement.ChartTitle>
                          Team Reports
                          <br />
                          ({overall_engagement_team_reports}, {
                            countOfCourseMembers > 0
                              ? Number(
                                (
                                  (overall_engagement_team_reports /
                                    countOfCourseMembers) *
                                  100
                                ).toFixed(2)
                              )
                              : 0
                          }%)
                        </Engagement.ChartTitle>
                        <BarChart
                          height={60}
                          color="#d7f0f2"
                          value={
                            countOfCourseMembers > 0
                              ? Number(
                                (
                                  (overall_engagement_team_reports /
                                    countOfCourseMembers) *
                                  100
                                ).toFixed(2)
                              )
                              : 0
                          }
                        />
                      </Engagement.Chart>
                    </Engagement.RightColumn>
                  </Engagement.Columns>
                </Styled.BlockContent>
              </Styled.Block>
              <Styled.Block isMenuExpanded={isMenuExpanded}>
                <Styled.BlockTitle>
                  <Engagement.Title>
                    <b>Performance</b> (%)
                  </Engagement.Title>
                  {
                    showPerformanceDowload &&
                    <Styled.DownloadLink href="#" onClick={this.downloadPerformanceData}>
                      {performanceDownloadRequest ? 'Download Data' : 'Download Request'}
                    </Styled.DownloadLink>
                  }
                </Styled.BlockTitle>
                <Styled.BlockContent>
                  <Styled.BlockHint>
                    Round {roundNumber}
                  </Styled.BlockHint>
                  <Performance.Columns>
                    <Performance.LeftColumn>
                      <Performance.BigPercentValue>
                        {averageTeamGrade > 0 ? `${(averageTeamGrade * 100).toFixed(0)}%` : "---"}
                      </Performance.BigPercentValue>
                      <Performance.PercentLabel>
                        Average Team Grade
                      </Performance.PercentLabel>
                      <Performance.PercentGroup>
                        <div>
                          <Performance.SmallPercentValue>
                            {medianTeamGrade > 0 ? `${(medianTeamGrade * 100).toFixed(0)}%` : "---"}
                          </Performance.SmallPercentValue>
                          <Performance.PercentLabel marginTop="4px">
                            Median
                          </Performance.PercentLabel>
                        </div>
                        <div>
                          <Performance.SmallPercentValue>
                            {standardDeviation > 0 ? `${(standardDeviation * 100).toFixed(0)}%` : "---"}
                          </Performance.SmallPercentValue>
                          <Performance.PercentLabel marginTop="4px">
                            σ (SD)
                          </Performance.PercentLabel>
                        </div>
                      </Performance.PercentGroup>
                    </Performance.LeftColumn>
                    <Performance.RightColumn>
                      <Performance.RightTitle>KPIs</Performance.RightTitle>
                      {roundNumber < 3 && (
                        <Performance.ButtonsGroup>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("Market Share")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            Market Share
                          </Performance.Button>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("Revenues")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            Revenues
                          </Performance.Button>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("Gross Margins")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            Gross Margins
                          </Performance.Button>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("Share Price")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            Share Price
                          </Performance.Button>
                        </Performance.ButtonsGroup>
                      )}
                      {roundNumber === 3 && (
                        <Performance.ButtonsGroup>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("Revenues")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            Revenues
                          </Performance.Button>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("Gross Margins")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            Gross Margins
                          </Performance.Button>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("RoE")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            RoE
                          </Performance.Button>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("RoA")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            RoA
                          </Performance.Button>
                        </Performance.ButtonsGroup>
                      )}
                      {roundNumber > 3 && (
                        <Performance.ButtonsGroup>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("RoE")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            RoE
                          </Performance.Button>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("RoA")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            RoA
                          </Performance.Button>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("EPS")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            EPS
                          </Performance.Button>
                          <Performance.Button
                            onClick={
                              metricsReports
                                ? () => this.showPerformanceModal("Share Price")
                                : doNothing
                            }
                            disabled={metricsReports ? false : true}
                          >
                            Share Price
                          </Performance.Button>
                        </Performance.ButtonsGroup>
                      )}
                    </Performance.RightColumn>
                  </Performance.Columns>
                </Styled.BlockContent>
              </Styled.Block>
              {!surveysError && (
                <Styled.Block isMenuExpanded={isMenuExpanded} twoColumnsLength={true}>
                  <Styled.BlockTitle>
                    <Engagement.Title>
                      <b>Team Insights</b>
                      {activeSurveyFinished && hasUserScores && (
                        <TeamDynamics.UpdateButton onClick={this.processUserScores}>
                          Update
                        </TeamDynamics.UpdateButton>
                      )}
                    </Engagement.Title>
                    {
                      !emptySurveys && activeSurveyFinished &&
                      <Styled.DownloadLink href="#" onClick={this.downloadTeamDynamicsData}>
                        {teamDynamicsDownloadRequest ? 'Download Data' : 'Download Request'}
                      </Styled.DownloadLink>
                    }
                  </Styled.BlockTitle>
                  <Styled.BlockContent>
                    {!emptySurveys && (
                      <Styled.BlockHint>
                        {currentSurveyName}
                      </Styled.BlockHint>
                    )}
                    {!emptySurveys && activeSurveyFinished && hasUserScores && (
                      <Styled.BlockHintStatus>
                        Updated
                      </Styled.BlockHintStatus>
                    )}
                    {
                      !emptySurveys && activeSurveyFinished &&
                      <TeamDynamics.Columns>
                        <TeamDynamics.LeftColumn>
                          <PieChart
                            width={160}
                            height={160}
                            margin={{ top: 0, left: 0, bottom: 0, right: 0 }}
                          >
                            <Tooltip formatter={value => `${Number(value).toFixed(2)}%`} separator=": " />
                            <Pie
                              data={[
                                {
                                  name: "Worked very well together",
                                  value: this.workedVeryWellTogether
                                },
                                {
                                  name: "Did not work well together",
                                  value: this.didNotWorkWellTogether
                                },
                                {
                                  name: "Worked well together",
                                  value: this.workedWellTogether
                                },
                              ]}
                              cx={80}
                              cy={80}
                              innerRadius="0%"
                              outerRadius="100%"
                              fill="#8884d8"
                              paddingAngle={1}
                              dataKey="value"
                              startAngle={270}
                              endAngle={630}
                              labelLine={false}
                            >
                              <Cell fill="#81c991" />
                              <Cell fill="#fd9595" />
                              <Cell fill="#ccedd1" />
                            </Pie>
                          </PieChart>
                        </TeamDynamics.LeftColumn>
                        <TeamDynamics.RightColumn>
                          <TeamDynamics.LabelsTitle>No. of teams</TeamDynamics.LabelsTitle>
                          <TeamDynamics.BorderedRight>
                            <TeamDynamics.LabelWrapper>
                              <TeamDynamics.LabelIcon color="#81c991" />
                              <TeamDynamics.Label
                                href="#"
                                onClick={this.showTeamDynamicsModal(MODAL_TYPE_WORKED_VERY_WELL)}
                              >
                                Worked very well together ({this.workedVeryWellTogetherTeams})
                              </TeamDynamics.Label>
                            </TeamDynamics.LabelWrapper>
                            <TeamDynamics.LabelWrapper>
                              <TeamDynamics.LabelIcon color="#ccedd1" />
                              <TeamDynamics.Label
                                href="#"
                                onClick={this.showTeamDynamicsModal(MODAL_TYPE_WORKED_WELL)}
                              >
                                Worked well together ({this.workedWellTogetherTeams})
                              </TeamDynamics.Label>
                            </TeamDynamics.LabelWrapper>
                            <TeamDynamics.LabelWrapper>
                              <TeamDynamics.LabelIcon color="#fd9595" />
                              <TeamDynamics.Label
                                href="#"
                                onClick={this.showTeamDynamicsModal(MODAL_TYPE_DID_NOT_WORK_WELL)}
                              >
                                Did not work well together ({this.didNotWorkWellTogetherTeams})
                              </TeamDynamics.Label>
                            </TeamDynamics.LabelWrapper>
                          </TeamDynamics.BorderedRight>
                        </TeamDynamics.RightColumn>
                      </TeamDynamics.Columns>
                    }
                    {
                      !emptySurveys && activeSurveyFinished && !hasUserScores && (
                        <TeamDynamics.WhiteOverlay>
                          {
                            processResultsFailed &&
                            <TeamDynamics.ProcessButton onClick={this.processUserScores}>
                              Process Results
                            </TeamDynamics.ProcessButton>
                          }
                        </TeamDynamics.WhiteOverlay>
                      )
                    }
                    {
                      emptySurveys &&
                      <TeamDynamics.LabelCentered>There are no peer evaluations created for this course.</TeamDynamics.LabelCentered>
                    }
                    {
                      !activeSurveyFinished &&
                      <TeamDynamics.LabelCentered>Peer evaluation has not closed yet</TeamDynamics.LabelCentered>
                    }
                  </Styled.BlockContent>
                </Styled.Block>)}
            </Styled.Row>
          </div>
          <Styled.Block isMenuExpanded={isMenuExpanded} twoRowsLength={true}>
            <Styled.BlockTitle>
              <Engagement.Title>
                <b>Team Leaderboard</b>
              </Engagement.Title>
              {!leaderboardFileDownloading && !teamPlayersLoading && (
                <CSVDownload
                  data={this.leaderboardCSVRows}
                  headers={this.leaderboardCSVHeaders}
                  separator={","}
                  enclosingCharacter={'"'}
                  filename={`leaderboard_${currentDate}.csv`}
                >
                  Download Data
                </CSVDownload>
              )}
              {(leaderboardLoading || teamPlayersLoading) && (
                <Styled.LoadingData>loading 60sec...</Styled.LoadingData>
              )}
            </Styled.BlockTitle>
            <Styled.BlockContent>
              <Styled.BlockHint>
                Round {roundNumber}
              </Styled.BlockHint>

              {!leaderboardLoading && (
                <Styled.BlockScroll>
                  <Leaderboard.Table isMenuExpanded={isMenuExpanded}>
                    <Leaderboard.Row isMenuExpanded={isMenuExpanded}>
                      <Leaderboard.Column
                        hasShadow={true}
                        hasSort={true}
                        onClick={() => this.changeSortOrder('classRanking')}
                      >
                        <span>
                          Rank
                        </span>
                        {sortOrder === "asc" &&
                          sortKey === "classRanking" && <Leaderboard.SortChar>▲</Leaderboard.SortChar>}
                        {sortOrder === "desc" &&
                          sortKey === "classRanking" && <Leaderboard.SortChar>▼</Leaderboard.SortChar>}
                      </Leaderboard.Column>
                      <Leaderboard.Column
                        hasShadow={true}
                        hasSort={true}
                        onClick={() => this.changeSortOrder('teamName')}
                      >
                        <span>
                          Team
                          {sortOrder === "asc" &&
                            sortKey === "teamName" && <Leaderboard.SortChar>▲</Leaderboard.SortChar>}
                          {sortOrder === "desc" &&
                            sortKey === "teamName" && <Leaderboard.SortChar>▼</Leaderboard.SortChar>}
                        </span>
                      </Leaderboard.Column>
                      <Leaderboard.Column
                        hasShadow={true}
                        hasSort={true}
                        onClick={() => this.changeSortOrder('teamPerformance')}
                      >
                        <span>
                          Score
                          {sortOrder === "asc" &&
                            sortKey === "teamPerformance" && <Leaderboard.SortChar>▲</Leaderboard.SortChar>}
                          {sortOrder === "desc" &&
                            sortKey === "teamPerformance" && <Leaderboard.SortChar>▼</Leaderboard.SortChar>}
                        </span>
                      </Leaderboard.Column>
                      <Leaderboard.Column hasShadow={true}>
                        <span>
                          Performance<br />Report
                        </span>
                      </Leaderboard.Column>
                    </Leaderboard.Row>
                    {this.leaderboardData.map((
                      {
                        key,
                        classRanking,
                        teamName,
                        teamPerformance,
                        detailsLink
                      },
                      index
                    ) => (
                      <Leaderboard.Row
                        key={key}
                        isIndex1={index === 0}
                        isIndex2={index === 1}
                        isIndex3={index === 2}
                        isMenuExpanded={isMenuExpanded}
                      >
                        <Leaderboard.Column>{classRanking}</Leaderboard.Column>
                        <Leaderboard.Column>{teamName}</Leaderboard.Column>
                        <Leaderboard.Column>{teamPerformance}</Leaderboard.Column>
                        <Leaderboard.Column>
                          <a href={detailsLink} target="_blank" rel="noreferrer">
                            View
                          </a>
                        </Leaderboard.Column>
                      </Leaderboard.Row>
                    ))}
                  </Leaderboard.Table>
                </Styled.BlockScroll>
              )}
              {leaderboardLoading && <Leaderboard.Loader>Loading...</Leaderboard.Loader>}
            </Styled.BlockContent>
          </Styled.Block>
        </Styled.Flex>
      </Styled.Body>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/instructor/containers/dashboard.js